export default __webpack_public_path__ + "static/media/social-twitter.1d8e5f0e.svg";